import product from './product';

function Description() {
  return <p className="product-description">{product.description}</p>;
}

export default Description;
